import { render, staticRenderFns } from "./NewAdminUserDialog.vue?vue&type=template&id=8cdc83bc&lang=pug&"
import script from "./NewAdminUserDialog.vue?vue&type=script&lang=ts&"
export * from "./NewAdminUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports